import { makeSx } from '../../../theme/_utils'

export default makeSx({
    CheckBatchButtonMenu: {
        maxWidth: '18rem',
        '& .MuiButton-root': {
            width: '100%',
            justifyContent: 'flex-start',
            textAlign: 'start',
        },
    },
})
